// AboutUs.js
import { Typography, IconButton, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div>
      <IconButton
        sx={{ color: "wheat", position: "absolute", top: 20, left: 20 }}
        onClick={() => navigate("/")}
      >
        <CloseIcon sx={{ fontSize: 30 }} />
      </IconButton>
      <Typography
        sx={{ mb: 4, color: "white", marginTop: 20, fontFamily: "Beckman" }}
        variant="h3"
        gutterBottom
        paragraph
        align="center"
        color="white"
      >
        ABOUT US
      </Typography>

      <Divider
        sx={{
          width: "30%",
          backgroundColor: "wheat",
          margin: "0 auto",
          borderBottomWidth: "3px",
        }}
      />

      <div style={{ textAlign: "center", marginLeft: 20, marginRight: 20 }}>
        <Typography
          align="center"
          sx={{
            mb: 4,
            color: "wheat",
            mt: 5,
            // fontFamily: "Beckman",
            fontSize: { xs: "1rem", md: "2.5rem" },
            whiteSpace: "pre-line", // This ensures \n gets rendered
          }}
        >
          {`Founded in 2016, Sruhad Investments Limited is a premier real estate developer.
We specialize in creating luxurious yet affordable residential spaces.
Our focus is on delivering elegance with practical accessibility.
Each home is thoughtfully designed for comfort and modern living.
We emphasize quality, innovation, and lasting value in every project.
Our team is committed to excellence and customer satisfaction.
Sustainability and community well-being are core to our values.
We aim to enhance the lives of our residents through smart design.
At Sruhad, we believe everyone deserves a home where they can thrive.`}
        </Typography>
      </div>
    </div>
  );
};

export default AboutUs;
